import React from 'react';
import PropType from 'prop-types';
import amplitude from 'amplitude-js/amplitude';

export default function ExternalLink({
  amplitudeEvent, amplitudeCTA, amplitudeTarget, amplitudeSource, children, text, href, className,
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      onClick={(amplitudeTarget || amplitudeSource) && amplitudeEvent ? () => amplitude.getInstance().logEvent(amplitudeEvent, { Target: amplitudeTarget, Source: amplitudeSource, CTA: amplitudeCTA }) : null}
    >
      {children || text}
    </a>
  );
}
ExternalLink.defaultProps = {
  children: null,
  text: null,
  className: null,
  amplitudeTarget: null,
  amplitudeSource: null,
  amplitudeEvent: null,
  amplitudeCTA: null,
};
ExternalLink.propTypes = {
  children: PropType.element,
  text: PropType.string,
  href: PropType.string.isRequired,
  className: PropType.string,
  amplitudeTarget: PropType.string,
  amplitudeEvent: PropType.string,
  amplitudeSource: PropType.string,
  amplitudeCTA: PropType.string,
};
